/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cash_FlowInputs */

const vi_nav_cash_flow = /** @type {(inputs: Nav_Cash_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng tiền`)
};

/**

* @param {Nav_Cash_FlowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_cash_flow = /** @type {((inputs?: Nav_Cash_FlowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cash_FlowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_cash_flow(inputs)
});